import i18next from 'i18next';

i18next.addResources('es', 'ExtraEvidence', {
  evidenceType: 'Tipo de prueba',
  detail: 'Detalle',
  part: 'Parte',
  status: 'Estado',
  searchBarPlaceholder: 'Tipo de prueba, detalle'
});
